// extracted by mini-css-extract-plugin
module.exports = {"wrap":"NotAvailable_wrap__QwuYm","align-left":"NotAvailable_align-left__3lrEl"};